<script>
export default {
    name: 'Logout',
    created() {
        localStorage.removeItem(this.$store.getters.appToken);
        this.$store.dispatch('logout');
        this.$router.push('/');
    }
};
</script>